import { ref } from 'vue';
import { getPusher } from '@/plugins/pusher';
import { getEcho } from '@/plugins/echo';

export function useBroadcast() {
    const isListening = ref(false);
    const channelListener = ref(null);
    const channelName = ref(null);
    const eventName = ref(null);
    const driver = process.env.VUE_APP_WEB_SOCKET_DRIVER || 'reverb';
    const echo = ref(null);


    const listen = (channel, event, callback) => {
        if (isListening.value) {
            console.warn('Already listening. Stop the current listener first.');
            return;
        }


        if (driver === 'pusher') {
            listenViaPusher(channel, event, callback);
        } else {
            echo.value = getEcho();
            listenViaReverb(channel, event, callback);
        }
    };


    const listenViaPusher = (channel, event, callback) => {
        console.log('pusher channel :>> ', channel);
        console.log('pusher event :>> ', event);

        try {
            const pusher = getPusher();
            const pusherChannel = pusher.subscribe(channel);

            const eventHandler = (data) => {
                console.log(`[Pusher] Event "${event}" received on channel "${channel}":`, data);
                callback(data);
            };

            pusherChannel.bind(event, eventHandler);

            channelListener.value = {
                type: 'pusher',
                channel: pusherChannel,
                eventHandler,
                event,
            };

            isListening.value = true;
            channelName.value = channel;
            eventName.value = event;
            console.log(`[Pusher] Started listening to "${channel}"`);
        }
        catch (error) {
            console.error('[Pusher] Error starting listener:', error);
            isListening.value = false;
        }
    };


    const listenViaReverb = (channel, event, callback) => {
        try {


            const eventHandler = (data) => {
                console.log(`[Reverb] Event "${event}" received on channel "${channel}":`, data);
                callback(data);
            };

            const listener = echo.value.channel(channel).listen("." + event, eventHandler);

            console.log('listener :>> ', listener);

            channelListener.value = {
                type: 'reverb',
                channel,
                eventHandler,
                event,
            };

            isListening.value = true;
            channelName.value = channel;
            eventName.value = event;
            console.log(`[Reverb] Started listening to "${channel}"`);
        } catch (error) {
            console.error('[Reverb] Error starting listener:', error);
            isListening.value = false;
        }
    };

    const stopListening = () => {
        if (!channelListener.value || !isListening.value) {
            return;
        }

        try {
            if (channelListener.value.type === 'pusher') {
                // ... existing pusher code ...
            } else if (channelListener.value.type === 'reverb' || channelListener.value.type === 'reverb-private') {
                // Use leaveChannel instead of echo.value.leave()
                if (channelListener.value.channelInstance) {
                    echo.value.leaveChannel(channelListener.value.channelInstance.name || channelName.value);
                } else {
                    echo.value.leave(channelName.value);
                }
                console.log(`[Reverb] Stopped listening to "${channelName.value}"`);
            }

            isListening.value = false;
            channelListener.value = null;
            channelName.value = null;
            eventName.value = null;
        } catch (error) {
            console.error('Error stopping listener:', error);
        }
    };


    const listenPrivate = (channel, event, callback) => {
        if (isListening.value) {
            console.warn('Already listening. Stop the current listener first.');
            return;
        }

        try {
            const eventHandler = (data) => {
                console.log(`[Reverb] Event "${event}" received on private channel "${channel}":`, data);
                callback(data);
            };

            echo.value.private(channel).listen(event, eventHandler);

            channelListener.value = {
                type: 'reverb-private',
                channel,
                eventHandler,
                event,
            };

            isListening.value = true;
            channelName.value = channel;
            eventName.value = event;
            console.log(`[Reverb] Started listening to private channel "${channel}"`);
        } catch (error) {
            console.error('[Reverb] Error starting private listener:', error);
            isListening.value = false;
        }
    };

    return {
        isListening,
        listen,
        stopListening,
        listenPrivate,
        driver,
    };
}